import React from 'react';
import { styled } from 'dripsy';

import { Image, IImageProps } from '../common/Image';

const Logo = styled(Image)({
  width: 146,
  height: 44,
});

export interface ILogoImageProps
  extends Omit<IImageProps, 'source'> {}

export function LogoImage(props: ILogoImageProps) {
  return (
    <Logo
      source={require('../../../assets/images/logo.png')}
      {...props}
    />
  );
}
